import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const Schema = yup.object().shape({
  address: yup.string().ensure().required('Please input address'),
})

export const resolver = yupResolver(Schema)
